import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderCLWC from "../../../../src/content/christianlifeandwitnesscourse/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderCLWC,
  React
};